import type { CharacterVoiceParam } from 'Types/character'

export const createDisabledCharacterVoiceParam = (): CharacterVoiceParam => ({
  voices: [],
  weights: [],
  voice_id: '',
  speed: 0,
  pitch: 0,
})

export const msgShouldShowVoiceTag = (
  voiceSupported: boolean | undefined,
  readableText: string
): boolean => {
  return voiceSupported !== false && readableText.trim().length > 0
}

type LegacyWholeMessageAudioSource = {
  audio_file_url?: string | null
  audio_file_key?: string | null
  audio_duration_secs?: number | string | null
  isEdited?: boolean
}

export const getLegacyWholeMessageAudio = (
  message: LegacyWholeMessageAudioSource
): { audioUrl: string; durationSecs: number } | null => {
  if (message.isEdited) return null

  const audioUrl = message.audio_file_url?.trim()
  const audioFileKey = message.audio_file_key?.trim()
  const durationSecs = Number(message.audio_duration_secs)

  if (!audioUrl || !audioFileKey || !Number.isFinite(durationSecs)) {
    return null
  }

  return {
    audioUrl,
    durationSecs,
  }
}

// 分段语音必须把 segmentIndex 编进 id，否则多个 chip 会共享 loading/playing 状态。
export function msgSegmentVoiceId(
  sequence: string = '',
  userId: string = '',
  charId: string = '',
  timeStamp: number = 0,
  segmentIndex: number = 0,
  msglen: number = 0
): string {
  return [
    'message-segment',
    sequence,
    userId,
    charId,
    timeStamp,
    segmentIndex,
    msglen,
  ].join(':')
}
